import { PartActionSelection, SelectedPartType, SelectedSerial } from './MobilePartActionsDialog.props';

const SECONDARY_ACTIONS = ['doa', 'clean', 'test', 'repair', 'adjust'];

export const OUT_SERIAL_ACTIONS = ['remove', 'replace'];
export const IN_SERIAL_ACTIONS = ['install', 'replace'];

export const isSecondaryAction = (code: string): boolean => SECONDARY_ACTIONS.includes(code);

export interface BulkPartActionItem {
  id: number;
  actionId?: number;
  execute: boolean;
  actionTypeCode: string;
  serviceId: number;
  installedOrMaintainedPartData: Record<string, unknown>;
  removedPartData: Record<string, unknown>;
  notes: string;
  isExceptionalCreation?: boolean;
  interactionForms?: unknown[];
  actionTriggers?: unknown[];
}

export interface BulkPartActionResponse {
  interactionFormData?: import('../../../../../../@types/service.type').InteractionFormData[];
}

interface BuildBulkItemParams {
  selectedAction: PartActionSelection;
  serviceId: number;
  notes: string;
  isExceptional: boolean;
  inSerial: SelectedSerial | null;
  outSerial: SelectedSerial | null;
  selectedPartType: SelectedPartType | null;
  buildPartTypePartData: (
    partType: SelectedPartType | null,
    id: number,
    code: string
  ) => Record<string, unknown>;
  buildBulkPartData: (
    serial: SelectedSerial | null,
    id: number,
    code: string
  ) => Record<string, unknown>;
}

export const buildBulkItem = (params: BuildBulkItemParams): BulkPartActionItem => {
  const {
    selectedAction,
    serviceId,
    notes,
    isExceptional,
    inSerial,
    outSerial,
    selectedPartType,
    buildPartTypePartData,
    buildBulkPartData,
  } = params;
  const code = selectedAction.code;

  if (isSecondaryAction(code)) {
    const partTypeData = buildPartTypePartData(selectedPartType, 1, code);
    const isDoa = code === 'doa';
    return {
      id: 1,
      execute: true,
      actionTypeCode: code,
      serviceId,
      installedOrMaintainedPartData: isDoa ? {} : partTypeData,
      removedPartData: isDoa ? partTypeData : {},
      notes: notes.trim() || '',
    };
  }

  return {
    id: 1,
    execute: true,
    actionTypeCode: code,
    serviceId,
    installedOrMaintainedPartData: buildBulkPartData(inSerial, 1, code) as Record<string, unknown>,
    removedPartData: buildBulkPartData(outSerial, 1, code) as Record<string, unknown>,
    notes: notes.trim() || '',
    ...(isExceptional && { isExceptionalCreation: true }),
  };
};
